import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase } from '@material-ui/core';
import useNotice from './useNotice';

// 상단 공지 띠 — 헤더 아래 한 줄. 닫으면 이 탭(세션)에서는 다시 보이지 않는다
const closedKey = (key) => 'qw_notice_banner_closed:' + key;

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 42,
    padding: '8px 48px',
    backgroundColor: '#fef7f5',
    borderBottom: '1px solid #ffe3d8',
    color: theme.palette.primary.dark,
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: -0.6,
    textAlign: 'center',
    wordBreak: 'keep-all',
  },
  close: {
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 30,
    height: 30,
    borderRadius: 15,
    color: '#a4a4ac',
    '&:hover': { color: theme.palette.primary.dark, backgroundColor: '#ffffff' },
  },
}));

// offsetTop: 헤더가 띠 위에 겹쳐 그려지는 레이아웃(모바일 헤더 50px)에서 그만큼 아래로 내린다
function NoticeBanner({ offsetTop = 0 }) {
  const cs = useStyles();
  const notice = useNotice();
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    if (!notice) return;
    try { setClosed(sessionStorage.getItem(closedKey(notice.key)) === '1'); } catch (e) { setClosed(false); }
  }, [notice]);

  if (!notice || !notice.showBanner || !notice.bannerText || closed) return null;

  const close = () => {
    try { sessionStorage.setItem(closedKey(notice.key), '1'); } catch (e) { /* 무시 */ }
    setClosed(true);
  };

  return (
    <div className={cs.root} role="status" style={offsetTop ? { marginTop: offsetTop } : undefined}>
      {notice.bannerText}
      <ButtonBase className={cs.close} aria-label="공지 닫기" onClick={close}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
      </ButtonBase>
    </div>
  );
}

export default NoticeBanner;
